import { render, staticRenderFns } from "./MoveItem.vue?vue&type=template&id=a3b4db1e&scoped=true&"
import script from "./MoveItem.vue?vue&type=script&lang=js&"
export * from "./MoveItem.vue?vue&type=script&lang=js&"
import style0 from "./MoveItem.vue?vue&type=style&index=0&id=a3b4db1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b4db1e",
  null
  
)

export default component.exports